var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainLayout',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"https://cdn.materialdesignicons.com/2.5.94/css/materialdesignicons.min.css"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }